// extracted by mini-css-extract-plugin
export default {"recordDetailContainer":"RecordDetail_recordDetailContainer__L8idH","detailLabel":"RecordDetail_detailLabel__maHCs","detailData":"RecordDetail_detailData__EeIqs"};